import { Box } from '@mui/material';

import { ActionNodeEditor } from 'ogp/components/views/management/workflows/common/workflow-editor/workflow-sidebar/edit-node-form/nodes/action-node-editor/action-node-editor';
import { EnrollNodeEditor } from 'ogp/components/views/management/workflows/common/workflow-editor/workflow-sidebar/edit-node-form/nodes/enroll-node-editor/enroll-node-editor';
import { WaitNodeEditor } from 'ogp/components/views/management/workflows/common/workflow-editor/workflow-sidebar/edit-node-form/nodes/wait-node-editor/wait-node-editor';
import { EditNodeFormProps } from './edit-node-form.types';

const editors: Partial<Record<string, React.ComponentType<EditNodeFormProps>>> = {
  enroll: EnrollNodeEditor,
  wait: WaitNodeEditor,
  action: ActionNodeEditor,
};

export const EditNodeForm = (props: EditNodeFormProps) => {
  const Editor = editors[String(props.node.type)];

  if (!Editor) {
    return (
      <Box>
        No editor registered for node type: <b>{String(props.node.type)}</b>
      </Box>
    );
  }

  return (
    <Box height="100%" display="flex" flexDirection="column" overflow="hidden">
      <Editor {...props} />
    </Box>
  );
};
